import { ArrowUpRight, Gauge, PackageSearch, ShieldAlert, Truck, Wallet } from 'lucide-react';

const iconMap = {
  guias_demoradas: Gauge,
  guias_sin_recepcion: PackageSearch,
  carga_retenida_activa: ShieldAlert,
  repartos_pendientes_cierre: Truck,
  entregas_fallidas_48h: ShieldAlert,
  valor_declarado_en_transito: Wallet,
};

export default function KpiMiniCard({ item, changed = false }) {
  const Icon = iconMap[item.codigo] || ArrowUpRight;
  return (
    <article className={`min-w-[180px] rounded-2xl border border-[rgba(var(--border),0.72)] bg-[rgba(var(--panel),0.98)] px-3 py-3 shadow-[0_14px_28px_rgba(var(--shadow),0.08)] ${changed ? 'metric-flash' : ''}`}>
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[rgba(var(--muted),0.9)]">{item.etiqueta}</p>
          <p className="mt-1 text-2xl font-semibold tracking-tight text-[rgb(var(--fg))]">{Number(item.valor || 0).toLocaleString('es-AR')}</p>
        </div>
        <div className="flex h-9 w-9 items-center justify-center rounded-2xl bg-[rgba(var(--brand),0.12)] text-[rgb(var(--brand))]">
          <Icon className="h-4 w-4" />
        </div>
      </div>
    </article>
  );
}
